export default __webpack_public_path__ + "static/media/include_3@3x.783bbbcd.jpg";